function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isClient, unrefElement } from '@vueuse/core';
import '../../../utils/index.mjs';
const buildPopperOptions = function (props) {
  let modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const placement = props.placement,
    strategy = props.strategy,
    popperOptions = props.popperOptions;
  const options = _objectSpread(_objectSpread({
    placement,
    strategy
  }, popperOptions), {}, {
    modifiers: [...genModifiers(props), ...modifiers]
  });
  deriveExtraModifiers(options, popperOptions == null ? void 0 : popperOptions.modifiers);
  return options;
};
const unwrapMeasurableEl = $el => {
  if (!isClient) return;
  return unrefElement($el);
};
function genModifiers(options) {
  const offset = options.offset,
    gpuAcceleration = options.gpuAcceleration,
    fallbackPlacements = options.fallbackPlacements;
  return [{
    name: "offset",
    options: {
      offset: [0, offset != null ? offset : 12]
    }
  }, {
    name: "preventOverflow",
    options: {
      padding: {
        top: 2,
        bottom: 2,
        left: 5,
        right: 5
      }
    }
  }, {
    name: "flip",
    options: {
      padding: 5,
      fallbackPlacements
    }
  }, {
    name: "computeStyles",
    options: {
      gpuAcceleration
    }
  }];
}
function deriveExtraModifiers(options, modifiers) {
  if (modifiers) {
    options.modifiers = [...options.modifiers, ...(modifiers != null ? modifiers : [])];
  }
}
export { buildPopperOptions, unwrapMeasurableEl };